import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PubNub from "pubnub";
import { PubNubProvider } from "pubnub-react";
import { Chat, MessageList, MessageInput } from "@pubnub/react-chat-components";
import { oldgenericApi, genericApi } from '../../../common/apiconfig'
import SimpleChat from '../../../videochat/chat/simple-chat/direct-chat';
import { HekmaTextSearchField } from '../../../globalcomponents/formElements';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Loader from '../../../common/loader';
const Chats = (props) => {
    console.log(props.formValues.studylist, "propsobj.formValues.studylist")
    const [progress, setProgress] = useState(false)
    let [treatments, setTreatments] = useState(props.formValues.studylist)
    let [channel, setChannel] = useState("")
    let [headerText, setHeadertext] = useState("")
    let [result, setResult] = useState([])
    let [valSearch, setValSearch] = useState('');
    let [searchResult, setSearchResult] = useState([])
    useEffect(() => {
        props.UpdateFormField({ name: "hidestudytab", value: false });
        console.log(treatments, "treatments")
        if (props.formValues.studylist?.length > 0) {
            for (let i = 0; i < props.formValues.studylist.length; i++) {
                getPatientsForTreatments(props.formValues.studylist[i], i)
            }
        }

        return () => {
            props.UpdateFormField({ name: "hidestudytab", value: true });
        };

    }, [props.formValues.patientdata]);
    /* Creates and configures your PubNub instance. Be sure to replace "myPublishKey" and "mySubscribeKey"
  with your own keyset. If you wish, modify the default "myFirstUser" userId value for the chat user. */
    const getPatientsForTreatments = async (obj, i) => {
        setProgress(true)
        let requestBody = {
            query: `query {
                  getStudySitePatientFetch(studyId: "${obj.treatmentPlanId}", siteId: "${props.formValues.autosite.sponsorAccountId}") {
                      studyId
                      siteId
                      patientId
                      subjectStatus
                      onboardStatus
                      subjectId
                      alternateId
                      firstName
                  middleName
                  lastName
                  email
                  phone
    
              }
          }`
        };
        requestBody = JSON.stringify(requestBody);
        let res = await genericApi('getStudySitePatientFetch', requestBody);
        setProgress(false)
        if (!res) {
            // Error handling
            //console.log('Error!')

        } else {
            let addPatToTreatments = [...treatments]
            if (res.data.getStudySitePatientFetch.length) {
                // setTreatments([...treatments,{...treatments[i],"patientData":res.data.getStudySitePatientFetch} ])    
                let patientdata = res.data.getStudySitePatientFetch
                addPatToTreatments[i]["patientdata"] = patientdata
                setTreatments(addPatToTreatments)
            } else {
                addPatToTreatments[i]["patientdata"] = []
                setTreatments(addPatToTreatments)
            }
            if (i + 1 === props.formValues.studylist.length) {
                callModifyData()
            }
        }
    }

    const callModifyData = () => {
        let modifyTrmt = [...treatments]
        const result = modifyTrmt?.reduce((acc, curr) => {
            curr?.patientdata?.forEach(patient => {
                const existingPatient = acc.find(p => p.patientId === patient.patientId);
                if (existingPatient) {
                    existingPatient.planName.push(curr.planName);
                } else {
                    acc.push({ patientId: patient.patientId, name: patient.firstName + ' ' + patient.lastName, planName: [curr.planName], email: patient.email });
                }
            });
            return acc;
        }, []);
        setResult(result)
        setSearchResult(result)
    }

    const pubnub = new PubNub({
        "publishKey": process.env.REACT_APP_PUBNUB_PUBLISHKEY,
        "subscribeKey": process.env.REACT_APP_PUBNUB_SUBSCRIBEKEY,
        userId: localStorage.getItem("loggedInUser"),
    });
    const currentChannel = "Default";
    const theme = "light";
    const chatFun = (patientInfo) => {
        console.log("dm_" + localStorage.getItem("loginUserId") + '_' + patientInfo.patientId, "channelid")
        setChannel("dm_" + localStorage.getItem("loginUserId") + '_' + patientInfo.patientId)
        setHeadertext(`Chat with ${patientInfo.name}`)
    }

    const searchHandle = (event) => {
        event.preventDefault();
        let value = event.target.value;
        setValSearch(value);
    }
    const searchSubmit = async (event) => {
        event.preventDefault();
        console.log(result,"results")
        if (valSearch.length) {
            const data = result.filter(item => item.name.toLowerCase().includes(valSearch.toLowerCase()));
            console.log(data);
            setSearchResult(data)
        }
    }
    return (
        <div className='row'>
            <Loader progress={progress} />
            <div className="d-flex mb-3 justify-content-end col-md-12">
                <h1 className="mr-auto primary-header">Patient List</h1>
            </div>
            <div className='col-md-5 chat-list' >
                <div className='mb-3'>
                    <form noValidate autoComplete="off" onSubmit={searchSubmit}>
                        <HekmaTextSearchField
                            name="accountgridsearch"// this name you need not to add in constant file unless if we use redux
                            // label="Search Account"
                            placeholder="Search Patients"
                            value={valSearch}
                            handleChange={searchHandle}
                            className="gridSearchField"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" onClick={searchSubmit} style={{ cursor: "pointer" }}>
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end" onClick={()=>{setValSearch(""); setSearchResult(result)}} style={{ cursor: "pointer" }}>
                                        X
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </form>
                </div>
                {
                    searchResult?.map((item, i) => {
                        console.log(item, "i")
                        return (

                            <div className='chat-patient' onClick={() => chatFun(item)}>
                                <div >
                                    {item.name} &nbsp;&nbsp; <span style={{ fontSize: "12px" }}><i>{item.email}</i></span>
                                </div>
                                <p>Case Management: {item?.planName?.join(", ")}</p>
                                {/* <div>{item.planName.map((plan,j)=>{
                                    return plan
                                })}</div> */}

                            </div>


                        )
                    })
                }

            </div>
            <div className="chat-container col-md-7">
                <PubNubProvider client={pubnub}>
                    {channel && <SimpleChat clientId={localStorage.getItem("loginUserId")} channel={{ name: channel, clientname: localStorage.getItem("loggedInUser") }} clientname={localStorage.getItem("loggedInUser")} header={headerText} />}
                </PubNubProvider>
            </div>
        </div>


    )
}

const mapStateToProps = (state) => {
    return {
        formValues: state.form,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        UpdateFormField: (obj) => {
            return dispatch({
                type: "UpdateFormField",
                value: obj.value,
                name: obj.name,
            });
        },
    };
};
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Chats)
);
